import type { PartnerRevision } from '@models/partner-revision';

import { createReducer, on } from '@ngrx/store';
import * as fromPartnerActions from '@stores/partner-revision/partner-revision.actions';

export const partnerRevisionFeatureKey = 'partnerRevisionState';

export type PartnerRevisionState =
  | {
      data: null;
      loaded: false;
    }
  | {
      data: PartnerRevision;
      loaded: true;
    };

const initialState: PartnerRevisionState = { data: null, loaded: false };

export const partnerRevisionReducer = createReducer<PartnerRevisionState>(
  initialState,
  on(fromPartnerActions.loadPartnerSuccess, (__, { partnerRevision }) => ({
    data: partnerRevision,
    loaded: true as const,
  })),
  on(fromPartnerActions.loadPartnerFailed, () => initialState),
  on(fromPartnerActions.setPartnerStatus, (state, { status }) => {
    if (!state.loaded) return state;
    return { loaded: true as const, data: { ...state.data, status } };
  }),
  on(fromPartnerActions.updatePartnerLocaleSuccess, (state, { locale }) => {
    if (!state.loaded) return state;
    return {
      loaded: true as const,
      data: {
        ...state.data,
        partner: {
          ...state.data.partner,
          configuration: { ...state.data.partner.configuration, locale },
        },
      },
    };
  })
);
